var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H11C12.1046 0 13 0.895431 13 2V11C13 12.1046 12.1046 13 11 13H2C0.89543 13 0 12.1046 0 11V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25713 2.15589C6.35833 1.94804 6.64167 1.94804 6.74287 2.15589L7.94912 4.63344C7.98874 4.71482 8.06309 4.77144 8.14917 4.78579L10.7699 5.22268C10.9897 5.25933 11.0773 5.54179 10.92 5.70691L9.04477 7.67501C8.98318 7.73965 8.95478 7.83126 8.96836 7.92151L9.3818 10.6691C9.41649 10.8996 9.18725 11.0742 8.98882 10.9683L6.62364 9.70714C6.54595 9.66572 6.45405 9.66572 6.37637 9.70715L4.01118 10.9683C3.81275 11.0742 3.58351 10.8996 3.6182 10.6691L4.03164 7.92151C4.04522 7.83126 4.01682 7.73965 3.95523 7.67501L2.08002 5.70691C1.9227 5.54179 2.01026 5.25933 2.23013 5.22268L4.85084 4.78579C4.93691 4.77144 5.01126 4.71482 5.05088 4.63344L6.25713 2.15589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreStarFull);
export default __webpack_public_path__ + "static/media/score-star-full.b98e541e353ae62df3df9773de9ebbc9.svg";
export { ForwardRef as ReactComponent };